import React from 'react'
import ReactDOM from 'react-dom/client'
import TextEditor from './TextEditor'


export class TextEditorElement extends HTMLElement {
  private reactRoot?: ReactDOM.Root
  private mountPoint?: HTMLDivElement

  connectedCallback() {
    const formRow = this.closest('.form-row')
    const textarea = formRow?.querySelector<HTMLTextAreaElement>('textarea') ?? null
    const initialValue = textarea?.value ?? ''
    const format = this.getAttribute('format')

    this.mountPoint = document.createElement('div')
    this.appendChild(this.mountPoint)

    this.reactRoot = ReactDOM.createRoot(this.mountPoint)
    this.reactRoot.render(
      <TextEditor
        initialValue={initialValue}
        format={format}
        onChange={(markdown) => {
          if (textarea) {
            textarea.value = markdown
            // Notify legacy jQuery listeners bound to the textarea,
            // since setting .value programmatically does not fire a native
            // event on its own.
            textarea.dispatchEvent(new Event('input', { bubbles: true }))
          }
        }}
      />
    )
  }

  disconnectedCallback() {
    this.reactRoot?.unmount()
    this.reactRoot = undefined
    this.mountPoint?.remove()
    this.mountPoint = undefined
  }
}

customElements.define('text-editor', TextEditorElement)
